console.log("Loaded");

// Marquee
function marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 0;

  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);

  setInterval(function () {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
}

// after window load: 1) class from data-marquee 2) speed 0.2
window.addEventListener("load", function () {
  document.querySelectorAll(".marquee").forEach(function (el) {
    var marquee_attr = el.getAttribute("data-marquee");
    if (marquee_attr) {
      marquee("." + marquee_attr, 0.2);
    }
  });
});

// Personalization (delegated clicks)
document.addEventListener("click", function (e) {
  var personalizeToggle = e.target.closest("#personalize_toggle");
  if (personalizeToggle) {
    console.log("personlization toggle clicked");
    personalizeToggle.classList.add("hide");
    document.querySelectorAll(".personalization_tab").forEach(function (tab) {
      tab.classList.remove("hide");
    });
    return;
  }

  var swatchBtn = e.target.closest(".swatch-button");
  if (swatchBtn) {
    console.log("clicked");
    var checkedPersonalization = document.querySelector(
      'input[name="personalizationprod"]:checked'
    );
    if (checkedPersonalization) {
      checkedPersonalization.checked = false;
    }
    var personalizeBtn = document.getElementById("personalize_btn");
    if (personalizeBtn) {
      personalizeBtn.setAttribute("disabled", "disabled");
    }
    return;
  }

  var viewAll = e.target.closest(".view_all");
  if (viewAll) {
    var wrapper = viewAll.closest(".collection-grid__wrapper");
    if (wrapper) {
      wrapper.querySelectorAll(".more_item").forEach(function (item) {
        item.style.display = "";
      });
    }
    viewAll.style.display = "none";
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('input[type=radio][name=personalizationprod]')
    .forEach(function (radio) {
      radio.addEventListener("change", function () {
        var checked = document.querySelector(
          'input[name="personalizationprod"]:checked'
        );
        if (!checked) return;

        var prod_val = checked.value;
        var prod_price = checked.getAttribute("data-price");
        var prod_sku = checked.getAttribute("data-sku");

        var variantsEl = document.getElementById("product-single__variants_options");
        if (variantsEl) {
          variantsEl.setAttribute("data-sku", prod_sku);
          variantsEl.setAttribute("value", prod_val);
          variantsEl.setAttribute("data-var-price", prod_price);
        }

        var addBtn = document.querySelector("[name=add]");
        var personalizeBtn = document.getElementById("personalize_btn");
        if (addBtn && !addBtn.disabled && personalizeBtn) {
          personalizeBtn.removeAttribute("disabled");
        }
      });
    });
});

// $('.single-item').slick();

// $(window).load(function() {
//   $(".pageloader").fadeOut("slow");
// });

// $(".overlay").fadeIn();
//         setTimeout(function(){
//           $(".overlay").fadeOut(2000);
//           $(".collslider-section").fadeIn(1000);
//         },500);

//complex collection
// $('.more_item').css('display','none');
